import { type ComponentProps, useEffect, useRef } from "react";

/** Give a second pointer click time to rename before opening the task drawer. */
export function TaskTitleButton({
  onOpen,
  onRename,
  ...props
}: Omit<ComponentProps<"button">, "onClick" | "onDoubleClick"> & {
  onOpen: () => void;
  onRename: () => void;
}) {
  const pendingOpen = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const cancelOpen = () => {
    clearTimeout(pendingOpen.current);
    pendingOpen.current = undefined;
  };
  useEffect(() => () => clearTimeout(pendingOpen.current), []);

  return (
    <button
      type="button"
      title="Double-click to rename"
      {...props}
      onClick={(event) => {
        event.stopPropagation();
        cancelOpen();
        // Keyboard and assistive-technology activation should open immediately.
        if (event.detail === 0) onOpen();
        else if (event.detail === 1) pendingOpen.current = setTimeout(onOpen, 350);
      }}
      onDoubleClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        cancelOpen();
        onRename();
      }}
    />
  );
}
